<template>
	 <v-container>
		 <v-dialog title="导入学员信息" v-model="hideShow" width="500" persistent>
			<v-card>
				
				<v-card-title>
					<span>导入学员信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<span class="mr-2">1.</span>
							<span class="mr-2">下载学员信息表导入模板</span>
							<a href="https://photo.youkeya.cn/assets/xls/Youkeya_Student_Import_1208.xlsx">立即下载导入模板</a>
						</v-col>
						<v-col cols="12">
							<span class="mr-2">2.</span>
							<span class="mr-2">打开模板excel,仔细阅读操作说明</span>
							<span style="color:red">注:模板的第一行不要改动</span>
						</v-col>
						<v-col cols="12">
							<span class="mr-2">3.</span>
							<span>选择录入好的学员信息excel表,点击开始导入</span>
						</v-col>
						<v-col cols="12" class="d-flex mt-2">
							<v-file-input @change="fileSelected" label="学员信息表" v-model="upload.files" show-size
								placeholder="请选择要导入的学员信息表" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" dense
								outlined small-chips />
						</v-col>
						<v-col cols="12" v-if="resData" class="d-flex flex-column flex-wrap">
							<v-btn color="info" @click="toImportResult">点击查看导入结果</v-btn>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" :loading="submiting" color="success">开始导入</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import * as XLSX from "xlsx";
	export default {
		name:"import-students",
		
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.upload.file = [];
					this.excleData = [];
					this.resData = null;
				}
			},
			
		},
		data(){
			return {
				shopId:"",
				upload:{
					files:[],
				},
				hideShow:this.show,
				excleData:[] ,// excel数据
				resData:null ,//返回的结果
				submiting:false
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			console.log("import-student mounted");
		},
		methods:{
			fileSelected(file) {
				console.log("开始检查文件的数据");
				console.log('file',file);
				
				//let files = file.target.files[0];
				let files = file;
				if (!files) {
					// 如果没有文件
					return false;
				} else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
					//alert("上传格式不正确，请上传xls或者xlsx格式");
					this.$noty.error("上传格式不正确，请上传xls或者xlsx格式")
					return false;
				}
				const fileReader = new FileReader();
				fileReader.onload = (e) => {
					try {
						const data = e.target.result;
						const workbook = XLSX.read(data, {
							type: "binary",
						});
						const wsname = workbook.SheetNames[0]; // 取第一张表
						const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
						console.log("ws", ws);
						let tempList = [];
						for (var i = 0; i < ws.length; i++) {
							let rowIndex = i + 2;
							if (
								ws[i].hasOwnProperty("姓名(必填)") &&
								ws[i].hasOwnProperty("性别(必填)") 
								
							) {
								let sheetData = {
									// 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
									studentName: ws[i]["姓名(必填)"].toString(),
									genderName: ws[i]["性别(必填)"].toString(),
									age: ws[i]["年龄"],
									contactorCall: ws[i]["联系人关系"],
									contactorMobile: ws[i]["联系人手机"],
									homeAddress:ws[i]["家庭住址"],
									studentSource:ws[i]["生源类型"],
									fromSchool:ws[i]["就读学校"],
									fromRegion:ws[i]["居住片区"],
									courseName:ws[i]["课程名称"],
									className:ws[i]["班级名称"],
									totalMoney:ws[i]["总缴费金额"],
									totalHours:ws[i]["总课时"],
									usedHours:ws[i]["已用课时"],
									giveTuition:ws[i]["赠送金额"],
									usedTuition:ws[i]["已用金额"],
									
								};
								
								if(sheetData.age){
									sheetData.age = sheetData.age.toString();
								}
								if(sheetData.contactorMobile){
									sheetData.contactorMobile = sheetData.contactorMobile.toString();
								}
								if(sheetData.totalMoney){
									sheetData.totalMoney = sheetData.totalMoney.toString();
								}
								if(sheetData.totalHours){
									sheetData.totalHours = sheetData.totalHours.toString();
								}
								if(sheetData.usedHours){
									sheetData.usedHours = sheetData.usedHours.toString();
								}
								if(sheetData.giveTuition){
									sheetData.giveTuition = sheetData.giveTuition.toString();
								}
								if(sheetData.usedTuition){
									sheetData.usedTuition = sheetData.usedTuition.toString();
								}
								
								
								
								tempList.push(sheetData);
							} else {
								//alert("导入Excel格式不正确");
								this.$noty.error("第"+rowIndex+"行姓名或性别为空")
								//this.upload.files = [];
								return;
							}
						}
						if (tempList.length == 0){
							this.$noty.error("未获取到表格数据,请检查导入的文件是否正确")
							return;
						}
						if (tempList.length > 600){
							this.$noty.error("一次最多支持导入600名学员")
							return;
						}
						this.excleData = tempList;
						console.log(tempList);
						
					} catch (e) {
						console.log("catch:",e);
						return false;
					}
				};
				fileReader.readAsBinaryString(files);
				//this.$refs.file.value = "";
				
			},
			submitAdd(){
				
				const studentCount = this.excleData.length;
				if (studentCount==0){
					this.$noty.error("请先选择待导入的学员信息表")
					return;
				}
				this.submiting = true;
				// api
				const that = this;
				let url = `/edu/student/batch/import`;
				let postData = {
					shopId:this.shopId,
					studentList:this.excleData
				};
				
				this.axios.post(url, postData).catch(() => {
					that.submiting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					console.log(res);
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("导入完成");
							
							that.resData = res.data["data"];
							//that.$emit("success","");
							
							this.upload.files =[];
							this.excleData = [];
							that.submiting = false;
							
							return;
						} else {
							that.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.submiting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
				
			},
			cancel(){
				this.$emit("cancel","");
			},
			toImportResult(){
				let data = {batchNo:this.resData}
				this.$emit("toResult",data);
			}
		}
	}
	
</script>

<style>
</style>
